<template>
    <div>
        <div class="select">
            <el-select style="width:100px; padding-right: 10px;" v-model="value" placeholder="请选择"
                       @change="province_change">
                <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
            <el-select style="width:150px; padding-right: 10px;" v-model="cityvalue" placeholder="请选择">
                <el-option
                        v-for="item in cityoptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
            <!--            <el-select v-model="maintypevalue" style="width:250px; padding-right: 10px;" placeholder="请选择"-->
            <!--                       @change="maintype_change" disabled>-->
            <!--                <el-option-->
            <!--                        v-for="(item, key) in maintypeoptions"-->
            <!--                        :key="key"-->
            <!--                        :label="item.label"-->
            <!--                        :value="item.value">-->
            <!--                </el-option>-->
            <!--            </el-select>-->
            <!--            <el-select v-model="typevalue" style="width:250px; padding-right: 10px;" placeholder="请选择"-->
            <!--                       disabled>-->
            <!--                <el-option-->
            <!--                        v-for="item in typeoptions"-->
            <!--                        :key="item.value"-->
            <!--                        :label="item.label"-->
            <!--                        :value="item.value">-->
            <!--                </el-option>-->
            <!--            </el-select>-->
            <!--            <el-select style="width:120px; padding-right: 10px;" v-model="eiatypevalue" placeholder="请选择"-->
            <!--                       disabled>-->
            <!--                <el-option-->
            <!--                        v-for="item in eiatypeoptions"-->
            <!--                        :key="item.value"-->
            <!--                        :label="item.label"-->
            <!--                        :value="item.value">-->
            <!--                </el-option>-->
            <!--            </el-select>-->
            <el-select style="width:300px; padding-right: 10px;" v-model="timevalue" placeholder="请选择">
                <el-option
                        v-for="item in timeoptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>

            <el-input style="width: 250px; padding-right:10px;"
                      placeholder="请输入检索关键字后按回车"
                      v-model="input"
                      clearable
                      @keydown.enter.native="search"
            >
            </el-input>
            <el-button type="primary" @click="search">查询</el-button>
            <el-tooltip
                    class="item"
                    effect="dark"
                    placement="top">
                <span slot="content" style="font-size: 10px; line-height:25px">每次导出数据最大限值为2000条，若超过限值，建议优化查询条件。</span>
                <el-button type="primary" @click="open">导出</el-button>
            </el-tooltip>
        </div>
        <div class="table">

            <el-table
                    v-loading="loading"
                    :data="tableData"
                    stripe
                    style="width: 100%"
                    height="100%">
                <!--                <el-table-column-->
                <!--                        fixed-->
                <!--                        type="expand"  @click="SearchHostProject">-->
                <!--                    <template slot-scope="props" @click="SearchHostProject">-->
                <!--                        <div @click="SearchHostProject" >asdf </div>-->
                <!--                        <el-form label-position="left" class="demo-table-expand" inline-->
                <!--                                 style="background-color: #DFEBF5 ">-->
                <!--                            <el-form-item label="编写项目">-->
                <!--                                <span>{{ props.row.id }}</span>-->
                <!--                            </el-form-item>-->


                <!--                        </el-form>-->
                <!--                    </template>-->

                <!--                </el-table-column>-->
                <template slot="empty">
                    <p>{{dataText}}</p>
                </template>
                <el-table-column
                        fixed
                        align="center"
                        prop="id"
                        label="序号"
                        width="50">
                </el-table-column>
                <el-table-column
                        fixed
                        align="center"
                        prop="compile_host__compile_host_name"
                        label="编制主持人员名称"
                        width="140">
                </el-table-column>
                <el-table-column
                        fixed
                        align="center"
                        prop="compile_host__compile_host_code"
                        label="信用代码"
                        width="120">
                </el-table-column>
                <el-tooltip content="Top center" placement="top">
                    <el-button>Dark</el-button>
                </el-tooltip>
                <el-table-column
                        align="center"
                        prop="compile_unit__compile_unit_name"
                        label="从业单位"
                        width="200">
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="baogaoshu"
                        label="报告书数量"
                        width="100">
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="baogaobiao"
                        label="报告表数量"
                        width="100">
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="discount"
                        label="折算数量"
                        width="100">
                    <template
                            slot="header"
                            slot-scope="scope">
                        折算数量
                        <el-tooltip
                                class="item"
                                effect="dark"
                                placement="top">
                            <div slot="content">折算数量 = 报告书数量 * 10 + 报告表数量，<br/>即：考虑实际报告书编制难度，将其转换成<br/>报告表后，合计的数量。</div>
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        label="平均业绩"
                        width="100">
                    <template
                            slot="header"
                            slot-scope="scope">
                        平均业绩
                        <el-tooltip
                                class="item"
                                effect="dark"
                                placement="top">
                            <div slot="content">全国有业绩主持人员的平均业绩与所在省份<br/>有业绩人员的平均业绩中，取较高值，即本<br/>次计算的平均业绩。</div>
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        <div v-if="scope.row.country_avg > scope.row.province_avg">{{scope.row.country_avg}}</div>
                        <div v-else>{{scope.row.province_avg}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        label="超出平均比率(倍)"
                        width="150">
                    <template slot-scope="scope">
                        <span>{{(scope.row.rate - 1).toFixed(2)}}</span><span style="font-size: 20px"> ↑</span>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        label="项目详情"
                        width="100">
                    <template slot-scope="scope">
                        <el-button size="small" type="info" plain round style="width: 80px"
                                   @click.native.prevent="queryData(scope.row.compile_host__compile_host_code)">查询
                        </el-button>
                    </template>
                </el-table-column>
                <div class="page">
                    <div class="pa">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[10, 20, 30, 40, 50]"
                                :page-size=pageSize
                                layout="total, sizes, prev, pager, next, jumper"
                                :total=total>
                        </el-pagination>
                    </div>
                </div>
            </el-table>
            <div class="page" v-show="this.tableData.length > 0">
                <div class="pa">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 30, 40, 50]"
                            :page-size=pageSize
                            layout="total, sizes, prev, pager, next, jumper"
                            :total=total>
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import screenfull from 'screenfull'
    import {high_yield_host_download} from "../../../../network/request";
    import {HighYieldHostDataSearch} from "../../../../network/projectAnalysis";
    import {Province} from "../../../../network/utils";
    import {Type} from "../../../../network/utils";

    export default {
        name: "HostAchievementv2",
        data() {
            return {
                options: [],
                cityoptions: [],
                value: '全国',
                cityvalue: '全省',
                maintypeoptions: [],
                maintypevalue: "全部大类",
                typeoptions: [],
                typevalue: "全部小类",

                valueTime: [],
                minMaxTime: [],
                eiatypevalue: "全部类型",
                eiatypeoptions: [
                    {value: "全部类型", label: "全部类型"},
                    {value: "报告书", label: "报告书"},
                    {value: "报告表", label: "报告表"},

                ],
                timevalue: "最近一月",
                timeoptions: [
                    {value: "最近一月", label: "最近一月"},
                    {value: "最近一季", label: "最近一季"},
                    {value: "最近一年", label: "最近一年"},

                ],
                input: "",
                tableData: [],
                dataText: '',
                total: 0,
                currentPage: 1,
                pageSize: 10,
                loading: true,
            }
        },
        methods: {
            open() {
                var mess = '本次查询数据共 ' + this.total + " 条，确认导出？";
                if (this.total > 2000) {
                    mess = '本次查询数据共 ' + this.total + " 条，超过导出数据最大限制量 2000 ，确认导出？";
                }
                ;
                this.$confirm(mess, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                        this.$message({
                            type: 'success',
                            message: '请求导出成功!'

                        });
                        this.download()
                    },
                ).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消导出操作'
                    });
                });
            },

            queryData(compile_host_code) {
                const {href} = this.$router.resolve({
                    name: 'HPDataSearchv2',
                    query: {
                        'compile_host_code': compile_host_code
                    }
                });
                window.open(href, "_blank");
            },

            province_change(val) {
                this.cityoptions = [];
                if (val === "全国") {
                    this.cityoptions.unshift({value: "全省", label: "全省"})
                    this.cityvalue = "全省"
                } else {
                    Province(val).then(response => {
                        for (var i = 0; i < response.data.length; i++) {
                            this.cityoptions.push({value: response.data[i]['city'], label: response.data[i]['city']})
                        }
                        this.cityoptions.unshift({value: "全省", label: "全省"})
                        this.cityvalue = "全省"
                    });
                }

            },
            maintype_change(val) {
                this.typeoptions = [];
                if (val === "全部大类") {

                    this.typeoptions.unshift({value: "全部小类", label: "全部小类"})
                    this.typevalue = "全部小类"

                } else {
                    Type(val).then(response => {
                        for (var i = 0; i < response.data.length; i++) {
                            this.typeoptions.push({
                                value: response.data[i]['type_name'],
                                label: response.data[i]['type_name']
                            })
                        }
                        this.typeoptions.unshift({value: "全部小类", label: "全部小类"})
                        this.typevalue = "全部小类"
                    });
                }

            },
            time_change(val) {
                this.minMaxTime = val
            },
            getFullCreeen() {
                if (screenfull.isEnabled) {
                    screenfull.toggle()
                }
            },
            download() {
                let province = (this.value === "全国") ? '' : this.value;
                let cityvalue = (this.cityvalue === "全省") ? '' : this.cityvalue;
                window.location.href = high_yield_host_download(province, cityvalue, this.timevalue, this.input)
            },
            getFormatDate(date) {
                let Str = date.getFullYear() + '-' +
                    ((date.getMonth() + 1).toString().length == 1 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-' +
                    (date.getDate().toString().length == 1 ? '0' + date.getDate() : date.getDate()) + ' ' +
                    (date.getHours().toString().length == 1 ? '0' + date.getHours() : date.getHours()) + ':' +
                    (date.getMinutes().toString().length == 1 ? '0' + date.getMinutes() : date.getMinutes()) + ':' +
                    (date.getSeconds().toString().length == 1 ? '0' + date.getSeconds() : date.getSeconds());
                return Str;
            },
            handleSizeChange(val) {
                this.loading = true;
                this.pageSize = val;
                this.currentPage = val;

                let province = (this.value === "全国") ? '全国' : this.value;
                let cityvalue = (this.cityvalue === "全省") ? '全省' : this.cityvalue;

                HighYieldHostDataSearch(province, cityvalue, this.timevalue, this.pageSize, this.currentPage, this.input).then(response => {
                    this.tableData = response.data['result'];
                    this.total = response.data['count']
                });
                if (this.tableData.length === 0) {
                    this.dataText = "暂无数据";
                }
            }
            ,
            handleCurrentChange(val) {
                this.loading = true;
                this.currentPage = val;

                let province = (this.value === "全国") ? '全国' : this.value;
                let cityvalue = (this.cityvalue === "全省") ? '全省' : this.cityvalue;

                // console.log(province, cityvalue, this.timevalue, this.currentPage, this.pageSize, this.input);
                HighYieldHostDataSearch(province, cityvalue, this.timevalue, this.pageSize, this.currentPage, this.input).then(response => {
                    this.tableData = response.data['result'];
                    this.total = response.data['count']
                });
                if (this.tableData.length === 0) {
                    this.dataText = "暂无数据";
                }

            },
            search() {
                this.loading = true;
                let province = (this.value === "全国") ? '全国' : this.value;
                let cityvalue = (this.cityvalue === "全省") ? '全省' : this.cityvalue;

                HighYieldHostDataSearch(province, cityvalue, this.timevalue, this.pageSize, this.currentPage, this.input).then(response => {
                    this.tableData = response.data['result'];

                    this.total = response.data['count']
                });
                if (this.tableData.length === 0) {
                    this.dataText = "暂无数据";
                }
            },
        },
        watch: {
            tableData: {
                handler() {
                    this.loading = false
                },
                deep: true,
            },
        },
        created() {
            this.valueTime = [new Date(new Date().getTime() - 3600 * 1000 * 24 * 365), new Date()]
            HighYieldHostDataSearch().then(response => {
                this.tableData = response.data['result'];
                this.total = response.data['count']
            });
            if (this.tableData.length === 0) {
                this.dataText = "暂无数据";
            }
            Province().then(response => {
                for (var i = 0; i < response.data.length; i++) {
                    this.options.push({value: response.data[i]['city'], label: response.data[i]['city']})
                }
                this.options.unshift({value: "全国", label: "全国"})
            });
            Type().then(response => {
                for (var i = 0; i < response.data.length; i++) {
                    this.maintypeoptions.push({
                        value: response.data[i]['type_name'],
                        label: response.data[i]['type_name']
                    })
                }
                this.maintypeoptions.unshift({value: "全部大类", label: "全部大类"})
            });
        }
    }
</script>

<style scoped>
    .table {
        height: 650px;
        width: 1200px;
        margin-left: 10px;
    }


    .page {
        background-color: #f7f7f7;
        z-index: 10;
        float: left;
        width: 100%;

    }

    .pa {
        display: flex;
        /*margin-left: 400px;*/
        align-items: center;
        justify-content: center;

    }

    .select {
        /*background-color: #bd81bb;*/
        width: 100%;
        z-index: -0;
        margin-top: 35px;
        padding: 10px;
    }

</style>